// Constants
import { BASE_ROUTE } from '../constants/bootstrap.constants';
// Enumeration
import { RoutesEnumeration } from 'enumerations/routes.enumeration';
// Utilities
import { generateAbsoluteRoute } from 'utils/app-routing.utils';

export const isONBPath = (): boolean => {
  return window.location.pathname.startsWith(
    generateAbsoluteRoute(RoutesEnumeration.ONBOARDING_LINK)
  );
};

export const startsWithBasePath = (): boolean => {
  return window.location.pathname.startsWith(BASE_ROUTE);
};

export const redirectToBasePath = (): void => {
  window.location.replace(
    BASE_ROUTE + window.location.pathname + window.location.search + window.location.hash
  );
};
